import { v4 as uuid } from 'uuid';
import Browser from 'bowser';

const COOKIE_DEVICE_ID_NAME = 'X-SE-Client-Id';

export const getCookie = (name: string) => {
    const deviceIdCookie = document.cookie.split(';').find((cookie) => cookie.split('=')[0].trim() === name);
    return deviceIdCookie ? deviceIdCookie.split('=')[1] : undefined;
};

export const setDeviceIDCookie = (deviceID: string) => {
    if (location.hostname === 'localhost') {
        // not possible to set cookie for another domain, this will default to localhost
        document.cookie = `${COOKIE_DEVICE_ID_NAME}=${deviceID};path=/`;
    } else {
        document.cookie = `${COOKIE_DEVICE_ID_NAME}=${deviceID};domain=screeningeagle.com;path=/`;
    }
};

export const getDeviceID = (): string => {
    let deviceID = getCookie(COOKIE_DEVICE_ID_NAME);
    if (!deviceID) {
        deviceID = uuid();
        setDeviceIDCookie(deviceID);
    }
    return deviceID;
};

export const browserParser = Browser.getParser(navigator.userAgent);

function isMacWithTouch(): boolean {
    return !!navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /Macintosh/.test(navigator.userAgent);
}

export function isIPad(): boolean {
    // In Safari, it is defaulted to use desktop web, thus need to check for mac with touch
    return browserParser.getPlatform().model === 'iPad' || isMacWithTouch();
}

export function isIPhone(): boolean {
    return browserParser.getPlatform().model === 'iPhone';
}

export function isChrome(): boolean {
    return browserParser.isBrowser('chrome', true);
}

export function isFireFox(): boolean {
    return browserParser.isBrowser('firefox', true);
}

// Refer: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/vendor
export function isSafari(): boolean {
    return browserParser.isBrowser('safari', true);
}

export const isMobileBrowser = () => browserParser.getPlatformType(true) === 'mobile';

function getMainVersion(version: string): number | undefined {
    if (!version) return undefined;
    const allVersions = version.split('.');
    const myVersion = Number(allVersions[0]);
    return isNaN(myVersion) ? undefined : myVersion;
}

export function getBrowserMainVersion(): number | undefined {
    return getMainVersion(browserParser.getBrowserVersion());
}

export function getOSMainVersion(): number | undefined {
    return getMainVersion(browserParser.getOSVersion());
}

export function getOSName(toLowerCase?: boolean) {
    return browserParser.getOSName(toLowerCase);
}
